<script setup>
const { percent, message } = defineProps({
    percent: {
        type: Number,
        required: true
    },
    message: {
        type: String,
        required: true
    }
})
</script>

<template>
    <div class="mt-[-75px] w-full bg-gray-200 rounded h-5 overflow-hidden max-w-[300px] md:max-w-[500px]">
        <div
            class="h-full bg-brand-400 transition-all duration-500"
            :style="{ width: percent + '%' }"
        ></div>
    </div>
    <h1 class="mt-7 text-brand-400 font-bold">{{message}}...</h1>

</template>

